var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Divider, Grid, Typography, useMediaQuery } from '@mui/material';
import { deepClone } from '@mui/x-data-grid/utils/utils';
import { t } from 'i18next';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { CheckAlterNatePartsUrl, CheckRepeatUrl, checkModelWisePeriodicPartURL, deleteRepeatChildsURL, getDeclinedStandardJobs, saveDeclinedPmPartsURl, standaredJobListUrl } from '../../../../api/url';
import { ChevronRightIcon } from '../../../../assets/customIcons';
import { MuiIconButton } from '../../../../builderPackage/components';
import { MuiStack } from '../../../../components';
import { MuiCheckBox } from '../../../../components/atoms/checkBox';
import { MuiLoaderButton } from '../../../../components/atoms/loaderButton';
import SkeletonLoader from '../../../../components/atoms/sketeton';
import { AlternatePartRelations, EModuleSection, EParentModuleName, ESystemName, LOCAL_STORAGE_KEYS } from '../../../../constants';
import { setIsTaskDetailsDataUpdated, setSavedTaskDetailsCount, setTaskDetailsDataSaved, setUpdatedModuleSectionByChannel, showLoader, showNotification } from '../../../../redux/commonSlice';
import { createAPI, getByIdAPI, getListAPI, setState } from '../../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { systemColor } from '../../../../theme/systemColor';
import { getLocalStorageItem } from '../../../../utils/storageHelper';
import useAnalyticsEventTracker from '../../../../utils/useAnalyticsEventTracker';
import { getSupersadeAlternatePartMessage } from '../../../../utils/utils';
import AlternatePartPopup from '../../../jobCard/revisedEstimate/taskDetailAccordians/alternatePartPopup';
import StandardJobsPartLabourDetailsDrawer from './standardJobsPartLabourDetailsDrawer';
var StandaredJobsComponent = function (props) {
    var _updatedModuleSection, _updatedModuleSection2;
    var trackButtonClick = useAnalyticsEventTracker("StandaredJobsComponent");
    var _a = props.callApIStatus, callApIStatus = _a === void 0 ? "false" : _a, SaveStandaredJobUrl = props.SaveStandaredJobUrl, parentModuleName = props.parentModuleName, getSavedStandaredJobUrl = props.getSavedStandaredJobUrl, _b = props.isSaveButton, isSaveButton = _b === void 0 ? true : _b, isDisabled = props.isDisabled, alternatePartConfigState = props.alternatePartConfigState, SystemName = props.SystemName, showRepeatItems = props.showRepeatItems;
    var dispatch = useAppDispatch();
    var _c = useState([]), standardJobs = _c[0], setStandardJobs = _c[1];
    var _d = useParams(), estimateId = _d.estimateId, appointmentId = _d.appointmentId, inspectionId = _d.inspectionId;
    var _e = useSelector(function (state) { return state.crud; }), ModuleDetailsGetById = _e.ModuleDetailsGetById, getModuleHeaderCount = _e.getModuleHeaderCount, repeatAlertConfiguration = _e.repeatAlertConfiguration;
    var updatedModuleSectionByChannel = useSelector(function (state) { return state.common; }).updatedModuleSectionByChannel;
    var _f = useState(0), saveCount = _f[0], setSaveCount = _f[1];
    var _g = useState(true), disableSaveButton = _g[0], setDisableSaveButton = _g[1];
    var _h = useState(true), isSkeleton = _h[0], setIsSkeleton = _h[1];
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var isDesktop = useMediaQuery(function (theme) { return theme.breakpoints.up('lg'); });
    var isMd = useMediaQuery(function (theme) { return theme.breakpoints.up('md'); });
    var _j = useState(false), alternetPartPopupOpen = _j[0], setAlternetPartPopupOpen = _j[1];
    var _k = useState([]), alterNatePartDetails = _k[0], setAlterNatePartDetails = _k[1];
    var _l = useState(null), searchedPart = _l[0], setSearchedPart = _l[1];
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var IsShowGroupItem = (_updatedModuleSection = updatedModuleSectionByChannel === null || updatedModuleSectionByChannel === void 0 || (_updatedModuleSection2 = updatedModuleSectionByChannel.find(function (it) { return (it === null || it === void 0 ? void 0 : it.Key) === EModuleSection.StandardJobs; })) === null || _updatedModuleSection2 === void 0 || (_updatedModuleSection2 = _updatedModuleSection2.Section) === null || _updatedModuleSection2 === void 0 ? void 0 : _updatedModuleSection2.IsShowGroupItem) !== null && _updatedModuleSection !== void 0 ? _updatedModuleSection : true;
    var _m = useState(false), isOpenJobItemDetailsDrawer = _m[0], setIsOpenJobItemDetailsDrawer = _m[1];
    var _o = useState(-1), drawerGroupIndex = _o[0], setDrawerGroupIndex = _o[1];
    var _p = useState(), selectedJobItemDetails = _p[0], setSelectedJobItemDetails = _p[1];
    var getStandardJobGroupTotal = function (option) {
        var _option$StandardServi, _option$StandardServi2;
        var partsTotalPrice = (_option$StandardServi = option.StandardServiceAssociation) === null || _option$StandardServi === void 0 || (_option$StandardServi = _option$StandardServi.Part) === null || _option$StandardServi === void 0 ? void 0 : _option$StandardServi.reduce(function (sum, part) {
            var _part$SelectedPriceDe, _part$SelectedPriceDe2;
            return sum + ((_part$SelectedPriceDe = part === null || part === void 0 || (_part$SelectedPriceDe2 = part.SelectedPriceDetails) === null || _part$SelectedPriceDe2 === void 0 ? void 0 : _part$SelectedPriceDe2.Amount) !== null && _part$SelectedPriceDe !== void 0 ? _part$SelectedPriceDe : 0);
        }, 0);
        var laboursTotalPrice = (_option$StandardServi2 = option.StandardServiceAssociation) === null || _option$StandardServi2 === void 0 || (_option$StandardServi2 = _option$StandardServi2.Labour) === null || _option$StandardServi2 === void 0 ? void 0 : _option$StandardServi2.reduce(function (sum, labour) {
            var _labour$SelectedPrice, _labour$SelectedPrice2;
            return sum + ((_labour$SelectedPrice = labour === null || labour === void 0 || (_labour$SelectedPrice2 = labour.SelectedPriceDetails) === null || _labour$SelectedPrice2 === void 0 ? void 0 : _labour$SelectedPrice2.Amount) !== null && _labour$SelectedPrice !== void 0 ? _labour$SelectedPrice : 0);
        }, 0);
        return ((partsTotalPrice || 0) + (laboursTotalPrice || 0)).toFixed(2);
    };
    var replacePart = function () {
        var stdJobs = __spreadArray([], standardJobs, true);
        var result = [];
        var alternatePart = alterNatePartDetails.find(function (item) { return item.isChecked; });
        if (alternatePart) {
            for (var _i = 0, stdJobs_1 = stdJobs; _i < stdJobs_1.length; _i++) {
                var stdJobItem = stdJobs_1[_i];
                var _stdJobItem$StandardS2;
                var PartList = [];
                for (var _a = 0, _b = (stdJobItem === null || stdJobItem === void 0 || (_stdJobItem$StandardS = stdJobItem.StandardServiceAssociation) === null || _stdJobItem$StandardS === void 0 ? void 0 : _stdJobItem$StandardS.Part) || []; _a < _b.length; _a++) {
                    var item = _b[_a];
                    var _stdJobItem$StandardS;
                    if (item.ChildId === (searchedPart === null || searchedPart === void 0 ? void 0 : searchedPart.ChildId)) {
                        PartList.push(_objectSpread(_objectSpread(_objectSpread({}, item), alternatePart), {}, {
                            ChildId: alternatePart.PartId,
                            HasAlternatePart: alternatePart.AssociationName === AlternatePartRelations.TwoWay
                        }));
                    }
                    else {
                        PartList.push(_objectSpread({}, item));
                    }
                }
                var StandardServiceAssociation = {
                    Labour: (stdJobItem === null || stdJobItem === void 0 || (_stdJobItem$StandardS2 = stdJobItem.StandardServiceAssociation) === null || _stdJobItem$StandardS2 === void 0 ? void 0 : _stdJobItem$StandardS2.Labour) || [],
                    Part: PartList
                };
                var standardPartObject = {
                    "StandardServiceGroupName": stdJobItem.StandardServiceGroupName,
                    "StandardServiceId": stdJobItem.StandardServiceId,
                    "isChecked": stdJobItem.isChecked,
                    StandardServiceAssociation: StandardServiceAssociation
                };
                result.push(standardPartObject);
            }
            setStandardJobs(result);
        }
        setAlternetPartPopupOpen(false);
    };
    var handleAlternatePartClick = function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var _ModuleDetailsGetById, _ModuleDetailsGetById2, alterNatePartPayload, result, _result$payload$data, alternateParts, alternatePartItem, temp, stdJobs, result_1, _i, stdJobs_2, stdJobItem, _stdJobItem$StandardS4, PartList, _a, _b, item_1, _stdJobItem$StandardS3, StandardServiceAssociation, standardPartObject;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    alterNatePartPayload = {
                        "PartId": item.ChildId,
                        OrganizationId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById === void 0 ? void 0 : _ModuleDetailsGetById.OrganizationId,
                        VinNo: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById2 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById2 === void 0 ? void 0 : _ModuleDetailsGetById2.VinNo
                    };
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _c.sent();
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "",
                            url: CheckAlterNatePartsUrl,
                            request: alterNatePartPayload
                        }))];
                case 2:
                    result = _c.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _c.sent();
                    if (result && result.payload && result.payload.success) {
                        alternateParts = (_result$payload$data = result.payload.data) !== null && _result$payload$data !== void 0 ? _result$payload$data : [];
                        alternatePartItem = alternateParts.find(function (item) { return item.AssociationName === AlternatePartRelations.Superseds; });
                        setSearchedPart(_objectSpread(_objectSpread({}, item), {}, {
                            Name: item.PartName,
                            SkuCode: item.PartCode,
                            isChecked: true
                        }));
                        temp = _objectSpread(_objectSpread({}, item), {}, {
                            Name: item.PartName,
                            SkuCode: item.PartCode,
                            isChecked: true
                        });
                        if (alternatePartItem) {
                            stdJobs = __spreadArray([], standardJobs, true);
                            result_1 = [];
                            for (_i = 0, stdJobs_2 = stdJobs; _i < stdJobs_2.length; _i++) {
                                stdJobItem = stdJobs_2[_i];
                                PartList = [];
                                for (_a = 0, _b = (stdJobItem === null || stdJobItem === void 0 || (_stdJobItem$StandardS3 = stdJobItem.StandardServiceAssociation) === null || _stdJobItem$StandardS3 === void 0 ? void 0 : _stdJobItem$StandardS3.Part) || []; _a < _b.length; _a++) {
                                    item_1 = _b[_a];
                                    if (item_1.ChildId === (temp === null || temp === void 0 ? void 0 : temp.ChildId)) {
                                        PartList.push(_objectSpread(_objectSpread(_objectSpread({}, item_1), alternatePartItem), {}, {
                                            ChildId: alternatePartItem.PartId,
                                            HasAlternatePart: alternatePartItem.AssociationName === AlternatePartRelations.TwoWay
                                        }));
                                    }
                                    else {
                                        PartList.push(_objectSpread({}, item_1));
                                    }
                                }
                                StandardServiceAssociation = {
                                    Labour: (stdJobItem === null || stdJobItem === void 0 || (_stdJobItem$StandardS4 = stdJobItem.StandardServiceAssociation) === null || _stdJobItem$StandardS4 === void 0 ? void 0 : _stdJobItem$StandardS4.Labour) || [],
                                    Part: PartList
                                };
                                standardPartObject = {
                                    "StandardServiceGroupName": stdJobItem.StandardServiceGroupName,
                                    "StandardServiceId": stdJobItem.StandardServiceId,
                                    "isChecked": stdJobItem.isChecked,
                                    StandardServiceAssociation: StandardServiceAssociation
                                };
                                result_1.push(standardPartObject);
                            }
                            setStandardJobs(result_1);
                            dispatch(showNotification({
                                isOpen: true,
                                message: getSupersadeAlternatePartMessage(alternatePartItem.PartName, item.PartName),
                                type: "success"
                            }));
                        }
                        else {
                            setAlterNatePartDetails(alternateParts);
                            setAlternetPartPopupOpen(alternateParts.length > 0);
                            setSearchedPart(_objectSpread(_objectSpread({}, item), {}, {
                                Name: item.PartName,
                                SkuCode: item.PartCode,
                                isChecked: true
                            }));
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        // getStandaredJobList()
        // getSavedStandaredJobList()
        if (callApIStatus && ModuleDetailsGetById.data) {
            getDetails();
        }
        return function () {
            setStandardJobs([]);
        };
    }, [callApIStatus, ModuleDetailsGetById]);
    var getDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                getStandaredJobList(ModuleDetailsGetById.data);
            }
            catch (e) {
                dispatch(showLoader({
                    isLoaderOpen: false
                }));
                console.log("Error-", e);
            }
            return [2 /*return*/];
        });
    }); };
    var getDeclinedStandardJobsList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _ModuleDetailsGetById3, _ModuleDetailsGetById4, _ModuleDetailsGetById5, _ModuleDetailsGetById6, _declinedJobsResponse, _declinedJobsResponse2, declineStandardJobRequestBody, declinedJobsResponse, declinedJobs, _declinedJobsResponse3, _declinedJobsResponse4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    declineStandardJobRequestBody = {
                        "ParentId": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById3 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById3 === void 0 ? void 0 : _ModuleDetailsGetById3.PreJobCardDocumentId,
                        "InstallBaseId": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById4 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById4 === void 0 ? void 0 : _ModuleDetailsGetById4.InstallBaseId,
                        "OrganizationId": selectedBranch.OrganizationId,
                        "VinNo": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById5 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById5 === void 0 ? void 0 : _ModuleDetailsGetById5.VinNo,
                        "Entity": ESystemName.Estimate,
                        "ServiceDetailType": 2,
                        "ServiceTypeId": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById6 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById6 === void 0 ? void 0 : _ModuleDetailsGetById6.RepairTypeId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: getDeclinedStandardJobs,
                            request: declineStandardJobRequestBody
                        }))];
                case 1:
                    declinedJobsResponse = _a.sent();
                    declinedJobs = [];
                    if ((_declinedJobsResponse = declinedJobsResponse.payload) !== null && _declinedJobsResponse !== void 0 && (_declinedJobsResponse = _declinedJobsResponse.value) !== null && _declinedJobsResponse !== void 0 && _declinedJobsResponse.success && (_declinedJobsResponse2 = declinedJobsResponse.payload) !== null && _declinedJobsResponse2 !== void 0 && (_declinedJobsResponse2 = _declinedJobsResponse2.value) !== null && _declinedJobsResponse2 !== void 0 && _declinedJobsResponse2.data) {
                        declinedJobs = (_declinedJobsResponse3 = declinedJobsResponse.payload) !== null && _declinedJobsResponse3 !== void 0 && (_declinedJobsResponse3 = _declinedJobsResponse3.value) !== null && _declinedJobsResponse3 !== void 0 && _declinedJobsResponse3.data ? (_declinedJobsResponse4 = declinedJobsResponse.payload) === null || _declinedJobsResponse4 === void 0 || (_declinedJobsResponse4 = _declinedJobsResponse4.value) === null || _declinedJobsResponse4 === void 0 ? void 0 : _declinedJobsResponse4.data : null;
                    }
                    return [2 /*return*/, declinedJobs];
            }
        });
    }); };
    function decoratePrice(part, mastersItem, index, jobType) {
        part.SelectedPriceDetails = part.Price;
        part.Price = mastersItem.StandardServiceAssociation[jobType][index].Price;
        return part;
    }
    var getStandaredJobList = function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var _response$payload, _response$payload2, request, _a, response, savedItemsList, declinedStandardJobsList, _response$payload$val, _response$payload3, mastersItemsList, newList_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    // setIsSkeleton(standardJobs.length > 0)
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    request = {
                        OrganizationId: item === null || item === void 0 ? void 0 : item.OrganizationId,
                        ProductId: item === null || item === void 0 ? void 0 : item.ProductId,
                        VinNo: item === null || item === void 0 ? void 0 : item.VinNo,
                        PreJobCardDocumentId: item.id,
                        Entity: SystemName
                    };
                    return [4 /*yield*/, Promise.all([dispatch(getByIdAPI({
                                key: 'StandaredJobList',
                                url: standaredJobListUrl,
                                request: request
                            })), getSavedStandaredJobList(), getDeclinedStandardJobsList()])];
                case 1:
                    _a = _b.sent(), response = _a[0], savedItemsList = _a[1], declinedStandardJobsList = _a[2];
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (response !== null && response !== void 0 && (_response$payload = response.payload) !== null && _response$payload !== void 0 && (_response$payload = _response$payload.value) !== null && _response$payload !== void 0 && _response$payload.success && (response === null || response === void 0 || (_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.value) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.statusCode) == 200) {
                        mastersItemsList = (_response$payload$val = response === null || response === void 0 || (_response$payload3 = response.payload) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3.value) === null || _response$payload3 === void 0 ? void 0 : _response$payload3.data) !== null && _response$payload$val !== void 0 ? _response$payload$val : [];
                        newList_1 = [];
                        mastersItemsList.forEach(function (mastersItem) {
                            var isSavedItem = savedItemsList === null || savedItemsList === void 0 ? void 0 : savedItemsList.find(function (existItem) { return existItem.StandardServiceId === mastersItem.StandardServiceId; });
                            var isDeclinedItem = declinedStandardJobsList === null || declinedStandardJobsList === void 0 ? void 0 : declinedStandardJobsList.find(function (declinedItem) { return declinedItem.StandardServiceId === mastersItem.StandardServiceId; });
                            if (isSavedItem) {
                                var _isSavedItem$Standard, _isSavedItem$Standard2;
                                var isSavedItemClone = _objectSpread({}, isSavedItem);
                                var decoratedStandardPartsList = {
                                    Part: (isSavedItem === null || isSavedItem === void 0 || (_isSavedItem$Standard = isSavedItem.StandardParts) === null || _isSavedItem$Standard === void 0 ? void 0 : _isSavedItem$Standard.Part.map(function (part, index) { return decoratePrice(part, mastersItem, index, 'Part'); })) || [],
                                    Labour: (isSavedItem === null || isSavedItem === void 0 || (_isSavedItem$Standard2 = isSavedItem.StandardParts) === null || _isSavedItem$Standard2 === void 0 ? void 0 : _isSavedItem$Standard2.Labour.map(function (labour, index) { return decoratePrice(labour, mastersItem, index, 'Labour'); })) || []
                                };
                                isSavedItemClone.StandardServiceAssociation = decoratedStandardPartsList;
                                delete isSavedItemClone.StandardParts;
                                var newItem = _objectSpread(_objectSpread({}, isSavedItemClone), {}, {
                                    isChecked: true
                                });
                                newList_1.push(newItem);
                            }
                            else if (isDeclinedItem) {
                                var _isDeclinedItem$Stand, _isDeclinedItem$Stand2;
                                var decoratedStandardPartsList = {
                                    Part: (isDeclinedItem === null || isDeclinedItem === void 0 || (_isDeclinedItem$Stand = isDeclinedItem.StandardParts) === null || _isDeclinedItem$Stand === void 0 || (_isDeclinedItem$Stand = _isDeclinedItem$Stand.Part) === null || _isDeclinedItem$Stand === void 0 ? void 0 : _isDeclinedItem$Stand.map(function (part, index) {
                                        return _objectSpread(_objectSpread({}, part), {}, {
                                            SelectedPriceDetails: part.SavedPriceWithTaxDeclined,
                                            Price: Array.isArray(part.Price) ? part.Price : [part.Price]
                                        });
                                    })) || [],
                                    Labour: (isDeclinedItem === null || isDeclinedItem === void 0 || (_isDeclinedItem$Stand2 = isDeclinedItem.StandardParts) === null || _isDeclinedItem$Stand2 === void 0 || (_isDeclinedItem$Stand2 = _isDeclinedItem$Stand2.Labour) === null || _isDeclinedItem$Stand2 === void 0 ? void 0 : _isDeclinedItem$Stand2.map(function (labour, index) {
                                        return _objectSpread(_objectSpread({}, labour), {}, {
                                            SelectedPriceDetails: labour.SavedPriceWithTaxDeclined,
                                            Price: Array.isArray(labour.Price) ? labour.Price : [labour.Price]
                                        });
                                    })) || []
                                };
                                newList_1.push(_objectSpread(_objectSpread(_objectSpread({}, mastersItem), isDeclinedItem), {}, {
                                    StandardServiceAssociation: decoratedStandardPartsList,
                                    isAlreadyDeclined: true
                                }));
                            }
                            else {
                                var mastersItemClone = _objectSpread({}, mastersItem);
                                mastersItemClone.StandardServiceAssociation = {
                                    Part: mastersItem.StandardServiceAssociation.Part.map(function (part) {
                                        var partClone = _objectSpread({}, part);
                                        partClone.SelectedPriceDetails = part.Price[0];
                                        return partClone;
                                    }),
                                    Labour: mastersItem.StandardServiceAssociation.Labour.map(function (labour) {
                                        var labourClone = _objectSpread({}, labour);
                                        labourClone.SelectedPriceDetails = labour.Price[0];
                                        return labourClone;
                                    })
                                };
                                newList_1.push(mastersItemClone);
                            }
                        });
                        setIsSkeleton(false);
                        setStandardJobs(newList_1);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getSavedStandaredJobList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _response$payload4, _response$payload5, request, response, _response$payload6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    request = {};
                    if (parentModuleName === EParentModuleName.ServiceEstimate) {
                        request = {
                            EstimateId: estimateId
                        };
                    }
                    if (parentModuleName === EParentModuleName.Appointment) {
                        request = {
                            AppointmentId: appointmentId
                        };
                    }
                    if (parentModuleName === EParentModuleName.Inspection) {
                        request = {
                            InspectionId: inspectionId
                        };
                    }
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: '',
                            url: getSavedStandaredJobUrl,
                            request: request
                        }))];
                case 1:
                    response = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (response !== null && response !== void 0 && (_response$payload4 = response.payload) !== null && _response$payload4 !== void 0 && _response$payload4.success && (response === null || response === void 0 || (_response$payload5 = response.payload) === null || _response$payload5 === void 0 ? void 0 : _response$payload5.statusCode) == 200) {
                        // setStandardJobs(response?.payload?.data)
                        return [2 /*return*/, response === null || response === void 0 || (_response$payload6 = response.payload) === null || _response$payload6 === void 0 || (_response$payload6 = _response$payload6.data) === null || _response$payload6 === void 0 ? void 0 : _response$payload6.StandardJob];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleCheckBoxClick = function (listItems) {
        var _list = __spreadArray([], standardJobs, true);
        var finalList = _list.map(function (item) { return item.StandardServiceId == listItems.StandardServiceId ? _objectSpread(_objectSpread({}, item), {}, {
            isChecked: !item.isChecked
        }) : item; });
        setStandardJobs(finalList);
        if (!listItems.isChecked) {
            setSaveCount(saveCount + 1);
        }
        dispatch(setIsTaskDetailsDataUpdated(true));
        setDisableSaveButton(false);
    };
    var handleSaveClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _ModuleDetailsGetById7, _ModuleDetailsGetById8, _res$payload, _ModuleDetailsGetById11, filterList, standardPartArray, standardLabourArray, rejectedStandardJobs, partList, checkModelWisePayload, res, finalStandardArray, payload, declinedStandardJobs, _ModuleDetailsGetById12, filterPriceLabour, _response$payload7, _response$payload8, response, _ModuleDetailsGetById13, _ModuleDetailsGetById14, _repeatAlertConfigura, _repeatAlertConfigura2, _repeatAlertConfigura3, saveDeclinedStandardJobsPayload, saveDeclinedStandardJobsResponse, _ModuleDetailsGetById15, _ModuleDetailsGetById16, _ModuleDetailsGetById17, repeatBody, deleteRepeatPartsBody, checkRepeatResponse, _checkRepeatResponse$, _checkRepeatResponse$2, _checkRepeatResponse$3, _checkRepeatResponse$4, _checkRepeatResponse$5, deleteRepeatResponse, sortedList_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    trackButtonClick("ButtonClickEvent", "StandardJobs_Save", undefined);
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    filterList = standardJobs.filter(function (item) { return item.isChecked; });
                    standardPartArray = [];
                    standardLabourArray = [];
                    rejectedStandardJobs = [];
                    partList = filterList.flatMap(function (item) {
                        var _item$StandardService;
                        return (item === null || item === void 0 || (_item$StandardService = item.StandardServiceAssociation) === null || _item$StandardService === void 0 || (_item$StandardService = _item$StandardService.Part) === null || _item$StandardService === void 0 ? void 0 : _item$StandardService.map(function (part) { return part; })) || [];
                    });
                    checkModelWisePayload = {
                        SourceAssociationId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById7 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById7 === void 0 ? void 0 : _ModuleDetailsGetById7.ProductId,
                        PartList: partList,
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        InstallBaseId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById8 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById8 === void 0 ? void 0 : _ModuleDetailsGetById8.InstallBaseId
                    };
                    return [4 /*yield*/, dispatch(createAPI({
                            key: '',
                            url: checkModelWisePeriodicPartURL,
                            request: checkModelWisePayload
                        }))];
                case 1:
                    res = _a.sent();
                    if (!(res !== null && res !== void 0 && (_res$payload = res.payload) !== null && _res$payload !== void 0 && _res$payload.success)) {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        return [2 /*return*/];
                    }
                    filterList.forEach(function (value) {
                        var _value$StandardServic, _value$StandardServic2;
                        var labour = (value === null || value === void 0 || (_value$StandardServic = value.StandardServiceAssociation) === null || _value$StandardServic === void 0 ? void 0 : _value$StandardServic.Labour) || [];
                        var part = (value === null || value === void 0 || (_value$StandardServic2 = value.StandardServiceAssociation) === null || _value$StandardServic2 === void 0 ? void 0 : _value$StandardServic2.Part) || [];
                        var objLabour = {};
                        var objPart = {};
                        labour.forEach(function (elem) {
                            var _ModuleDetailsGetById9;
                            objLabour['Quantity'] = elem.Quantity;
                            objLabour['SystemName'] = 'Labour';
                            objLabour['ChildId'] = elem.ChildId;
                            objLabour.OrganizationId = selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId;
                            objLabour.VinNo = ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById9 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById9 === void 0 ? void 0 : _ModuleDetailsGetById9.VinNo;
                            objLabour['StandardServiceId'] = value.StandardServiceId;
                            objLabour['ChildName'] = elem === null || elem === void 0 ? void 0 : elem.LabourName;
                            objLabour['ChildCode'] = elem === null || elem === void 0 ? void 0 : elem.LabourCode;
                            objLabour.UnitOfMeasurementId = elem === null || elem === void 0 ? void 0 : elem.UnitOfMeasurementId;
                            objLabour.Price = elem === null || elem === void 0 ? void 0 : elem.SelectedPriceDetails;
                            objLabour.ServiceTypeId = elem === null || elem === void 0 ? void 0 : elem.ServiceTypeId;
                            standardLabourArray.push(_objectSpread({}, objLabour));
                        });
                        part.forEach(function (item) {
                            var _ModuleDetailsGetById10;
                            objPart['Quantity'] = item.Quantity;
                            objPart['SystemName'] = 'Product';
                            objPart['ChildId'] = item.ChildId;
                            objPart.OrganizationId = selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId;
                            objPart.VinNo = ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById10 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById10 === void 0 ? void 0 : _ModuleDetailsGetById10.VinNo;
                            objPart['StandardServiceId'] = value.StandardServiceId;
                            objPart['ChildName'] = item === null || item === void 0 ? void 0 : item.PartName;
                            objPart['ChildCode'] = item === null || item === void 0 ? void 0 : item.PartCode;
                            objPart.UnitOfMeasurementId = item === null || item === void 0 ? void 0 : item.UnitOfMeasurementId;
                            objPart.Price = item === null || item === void 0 ? void 0 : item.SelectedPriceDetails;
                            objPart.ServiceTypeId = item === null || item === void 0 ? void 0 : item.ServiceTypeId;
                            standardPartArray.push(_objectSpread({}, objPart));
                        });
                    });
                    finalStandardArray = standardLabourArray.concat(standardPartArray);
                    payload = {};
                    // if (finalStandardArray.length > 0) {
                    payload = _objectSpread(_objectSpread({}, payload), {}, {
                        StandardParts: finalStandardArray,
                        RepairTypeId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById11 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById11 === void 0 ? void 0 : _ModuleDetailsGetById11.RepairTypeId
                    });
                    declinedStandardJobs = standardJobs.filter(function (item) { return !item.isChecked && item.isAlreadyDeclined; });
                    console.log("declinedStandardJobs", declinedStandardJobs);
                    declinedStandardJobs.map(function (item) {
                        var _item$StandardParts, _item$StandardParts2;
                        var labour = (_item$StandardParts = item.StandardParts) === null || _item$StandardParts === void 0 ? void 0 : _item$StandardParts.Labour;
                        var part = (_item$StandardParts2 = item.StandardParts) === null || _item$StandardParts2 === void 0 ? void 0 : _item$StandardParts2.Part;
                        labour.forEach(function (elem) {
                            rejectedStandardJobs.push({
                                SystemName: "Labour",
                                ChildId: elem.ChildId,
                                DeclineDateTime: new Date(),
                                Remarks: elem.Remarks ? elem.Remarks : "",
                                ServiceTypeId: elem.ServiceTypeId,
                                DeclinedJobReasonId: elem.DeclinedJobReasonId ? elem.DeclinedJobReasonId : null,
                                ServiceDetailType: 2,
                                ParentSystemName: SystemName,
                                Price: elem.Price ? Number(elem === null || elem === void 0 ? void 0 : elem.Price) : 0,
                                Quantity: elem.Quantity,
                                ServiceGroupId: item.StandardServiceId
                            });
                        });
                        part.forEach(function (elem) {
                            rejectedStandardJobs.push({
                                SystemName: "Product",
                                ChildId: elem.ChildId,
                                DeclineDateTime: new Date(),
                                Remarks: elem.Remarks ? elem.Remarks : "",
                                ServiceTypeId: elem.ServiceTypeId,
                                DeclinedJobReasonId: elem.DeclinedJobReasonId ? elem.DeclinedJobReasonId : null,
                                ServiceDetailType: 2,
                                ParentSystemName: SystemName,
                                Price: elem.Price ? Number(elem === null || elem === void 0 ? void 0 : elem.Price) : 0,
                                Quantity: elem.Quantity,
                                ServiceGroupId: item.StandardServiceId
                            });
                        });
                    });
                    if (parentModuleName === EParentModuleName.ServiceEstimate) {
                        payload = _objectSpread(_objectSpread({}, payload), {}, {
                            EstimateId: estimateId
                        });
                    }
                    if (parentModuleName === EParentModuleName.Appointment) {
                        payload = _objectSpread(_objectSpread({}, payload), {}, {
                            AppointmentId: appointmentId
                        });
                    }
                    if (parentModuleName === EParentModuleName.Inspection) {
                        payload = _objectSpread(_objectSpread({}, payload), {}, {
                            InspectionId: inspectionId,
                            RepairTypeId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById12 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById12 === void 0 ? void 0 : _ModuleDetailsGetById12.RepairTypeId
                        });
                    }
                    filterPriceLabour = finalStandardArray === null || finalStandardArray === void 0 ? void 0 : finalStandardArray.filter(function (item) { return item.SystemName === "Labour" && (!item.Price || item.Price.Amount === 0); });
                    if (!((filterPriceLabour === null || filterPriceLabour === void 0 ? void 0 : filterPriceLabour.length) > 0)) return [3 /*break*/, 2];
                    dispatch(showNotification({
                        isOpen: true,
                        message: /*#__PURE__*/ React.createElement("p", null, t("Price for each selected Labour Job items must be greater than zero"), /*#__PURE__*/ React.createElement("br", null)),
                        type: "error"
                    }));
                    return [3 /*break*/, 8];
                case 2: return [4 /*yield*/, dispatch(getListAPI({
                        key: '',
                        url: SaveStandaredJobUrl,
                        request: payload
                    }))];
                case 3:
                    response = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (!(response !== null && response !== void 0 && (_response$payload7 = response.payload) !== null && _response$payload7 !== void 0 && (_response$payload7 = _response$payload7.value) !== null && _response$payload7 !== void 0 && _response$payload7.success && (response === null || response === void 0 || (_response$payload8 = response.payload) === null || _response$payload8 === void 0 || (_response$payload8 = _response$payload8.value) === null || _response$payload8 === void 0 ? void 0 : _response$payload8.statusCode) == 200)) return [3 /*break*/, 8];
                    dispatch(setSavedTaskDetailsCount({
                        standardJobsCount: saveCount
                    }));
                    dispatch(setState({
                        key: "getModuleHeaderCount",
                        value: _objectSpread(_objectSpread({}, getModuleHeaderCount), {}, {
                            StandardParts: filterList.length
                        })
                    }));
                    dispatch(setTaskDetailsDataSaved(true));
                    setDisableSaveButton(true);
                    dispatch(showNotification({
                        isOpen: true,
                        message: "Standard jobs saved successfully",
                        type: "success"
                    }));
                    saveDeclinedStandardJobsPayload = {
                        "InstallBaseId": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById13 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById13 === void 0 ? void 0 : _ModuleDetailsGetById13.InstallBaseId,
                        "DeclinedJobs": rejectedStandardJobs,
                        "ParentId": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById14 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById14 === void 0 ? void 0 : _ModuleDetailsGetById14.PreJobCardDocumentId,
                        ServiceDetailType: 2
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "declinedPmParts",
                            url: saveDeclinedPmPartsURl,
                            request: saveDeclinedStandardJobsPayload
                        }))];
                case 4:
                    saveDeclinedStandardJobsResponse = _a.sent();
                    if (!(repeatAlertConfiguration !== null && repeatAlertConfiguration !== void 0 && (_repeatAlertConfigura = repeatAlertConfiguration.data) !== null && _repeatAlertConfigura !== void 0 && _repeatAlertConfigura.Transaction && Array.isArray(repeatAlertConfiguration === null || repeatAlertConfiguration === void 0 || (_repeatAlertConfigura2 = repeatAlertConfiguration.data) === null || _repeatAlertConfigura2 === void 0 ? void 0 : _repeatAlertConfigura2.Transaction) && repeatAlertConfiguration !== null && repeatAlertConfiguration !== void 0 && (_repeatAlertConfigura3 = repeatAlertConfiguration.data) !== null && _repeatAlertConfigura3 !== void 0 && _repeatAlertConfigura3.Transaction.includes(parentModuleName))) return [3 /*break*/, 7];
                    repeatBody = {
                        "InstallBaseId": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById15 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById15 === void 0 ? void 0 : _ModuleDetailsGetById15.InstallBaseId,
                        "CurrentODOMeterReading": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById16 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById16 === void 0 ? void 0 : _ModuleDetailsGetById16.ODOMeterReading,
                        "CurrentJobCardDate": moment().startOf('day'),
                        "CurrentJobCardParentOrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
                        "CurrentJobCardOrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        "CurrentJobCardRepairTypeId": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById17 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById17 === void 0 ? void 0 : _ModuleDetailsGetById17.RepairTypeId,
                        "CurrentComplaints": [],
                        "CurrentParts": finalStandardArray.filter(function (item) { return item.SystemName === "Product"; }).map(function (item) { return item.ChildId; }),
                        "CurrentLabours": finalStandardArray.filter(function (item) { return item.SystemName === "Labour"; }).map(function (item) { return item.ChildId; })
                    };
                    deleteRepeatPartsBody = {};
                    if (parentModuleName === EParentModuleName.ServiceEstimate) {
                        deleteRepeatPartsBody.ParentId = estimateId;
                        repeatBody.ParentId = estimateId;
                    }
                    if (parentModuleName === EParentModuleName.Appointment) {
                        deleteRepeatPartsBody.ParentId = appointmentId;
                        repeatBody.ParentId = appointmentId;
                    }
                    if (parentModuleName === EParentModuleName.Inspection) {
                        deleteRepeatPartsBody.ParentId = inspectionId;
                        repeatBody.ParentId = inspectionId;
                    }
                    return [4 /*yield*/, dispatch(createAPI({
                            url: CheckRepeatUrl,
                            request: repeatBody
                        }))];
                case 5:
                    checkRepeatResponse = _a.sent();
                    if (showRepeatItems) {
                        if (checkRepeatResponse && checkRepeatResponse !== null && checkRepeatResponse !== void 0 && (_checkRepeatResponse$ = checkRepeatResponse.payload) !== null && _checkRepeatResponse$ !== void 0 && _checkRepeatResponse$.success && checkRepeatResponse !== null && checkRepeatResponse !== void 0 && (_checkRepeatResponse$2 = checkRepeatResponse.payload) !== null && _checkRepeatResponse$2 !== void 0 && _checkRepeatResponse$2.data) {
                            if (checkRepeatResponse !== null && checkRepeatResponse !== void 0 && (_checkRepeatResponse$3 = checkRepeatResponse.payload) !== null && _checkRepeatResponse$3 !== void 0 && (_checkRepeatResponse$3 = _checkRepeatResponse$3.data) !== null && _checkRepeatResponse$3 !== void 0 && _checkRepeatResponse$3.ChildAssociations && (checkRepeatResponse === null || checkRepeatResponse === void 0 || (_checkRepeatResponse$4 = checkRepeatResponse.payload) === null || _checkRepeatResponse$4 === void 0 || (_checkRepeatResponse$4 = _checkRepeatResponse$4.data) === null || _checkRepeatResponse$4 === void 0 ? void 0 : _checkRepeatResponse$4.ChildAssociations.length) > 0) {
                                showRepeatItems(checkRepeatResponse === null || checkRepeatResponse === void 0 || (_checkRepeatResponse$5 = checkRepeatResponse.payload) === null || _checkRepeatResponse$5 === void 0 || (_checkRepeatResponse$5 = _checkRepeatResponse$5.data) === null || _checkRepeatResponse$5 === void 0 ? void 0 : _checkRepeatResponse$5.ChildAssociations, finalStandardArray);
                            }
                        }
                    }
                    if (!(rejectedStandardJobs.length > 0)) return [3 /*break*/, 7];
                    deleteRepeatPartsBody.Childs = rejectedStandardJobs.map(function (item) {
                        return item.ChildId ? item.ChildId : item.id;
                    });
                    return [4 /*yield*/, dispatch(getListAPI({
                            url: deleteRepeatChildsURL,
                            request: deleteRepeatPartsBody
                        }))];
                case 6:
                    deleteRepeatResponse = _a.sent();
                    _a.label = 7;
                case 7:
                    sortedList_1 = [];
                    updatedModuleSectionByChannel.map(function (item) {
                        var data = deepClone(item);
                        if (item.Key == EModuleSection.StandardJobs) {
                            // data.SectionAttributes[0].MANDATORY = filterList.length > 0 ? true : false
                            // data.SectionAttributes[0].MANDATORYDefaultValue = filterList.length > 0 ? true : false
                        }
                        sortedList_1.push(data);
                    });
                    dispatch(setUpdatedModuleSectionByChannel(sortedList_1));
                    _a.label = 8;
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var openJobDetailsDrawer = function (item, index) {
        if (item !== null && item !== void 0 && item.StandardServiceAssociation) {
            var _item$StandardService2, _item$StandardService3, _item$StandardService4, _item$StandardService5;
            var tempJobItemDetails = _objectSpread(_objectSpread({}, item), {}, {
                PartsLaboursList: __spreadArray(__spreadArray([], (item === null || item === void 0 || (_item$StandardService2 = item.StandardServiceAssociation) === null || _item$StandardService2 === void 0 || (_item$StandardService2 = _item$StandardService2.Labour) === null || _item$StandardService2 === void 0 ? void 0 : _item$StandardService2.map(function (labour) { return _objectSpread(_objectSpread({}, labour), {}, {
                    jobType: 'Labour'
                }); })), true), (item === null || item === void 0 || (_item$StandardService3 = item.StandardServiceAssociation) === null || _item$StandardService3 === void 0 || (_item$StandardService3 = _item$StandardService3.Part) === null || _item$StandardService3 === void 0 ? void 0 : _item$StandardService3.map(function (part) { return _objectSpread(_objectSpread({}, part), {}, {
                    jobType: 'Part'
                }); })), true),
                LabourCount: item === null || item === void 0 || (_item$StandardService4 = item.StandardServiceAssociation) === null || _item$StandardService4 === void 0 || (_item$StandardService4 = _item$StandardService4.Labour) === null || _item$StandardService4 === void 0 ? void 0 : _item$StandardService4.length,
                PartsCount: item === null || item === void 0 || (_item$StandardService5 = item.StandardServiceAssociation) === null || _item$StandardService5 === void 0 || (_item$StandardService5 = _item$StandardService5.Part) === null || _item$StandardService5 === void 0 ? void 0 : _item$StandardService5.length
            });
            tempJobItemDetails === null || tempJobItemDetails === void 0 || delete tempJobItemDetails.StandardServiceAssociation;
            setSelectedJobItemDetails(tempJobItemDetails);
            setIsOpenJobItemDetailsDrawer(true);
            setDrawerGroupIndex(index);
        }
    };
    var handleClose = function (updatedList) {
        var tempStandardJobs = __spreadArray([], standardJobs, true);
        var labourJobs = updatedList.filter(function (item) { return item.jobType === 'Labour'; });
        var partJobs = updatedList.filter(function (item) { return item.jobType === 'Part'; });
        var StandardServiceAssociation = {
            Labour: labourJobs,
            Part: partJobs
        };
        tempStandardJobs[drawerGroupIndex] = _objectSpread(_objectSpread({}, tempStandardJobs[drawerGroupIndex]), {}, {
            PartsLaboursList: StandardServiceAssociation,
            StandardServiceAssociation: StandardServiceAssociation
        });
        setStandardJobs(tempStandardJobs);
        setIsOpenJobItemDetailsDrawer(false);
        setDrawerGroupIndex(-1);
    };
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, standardJobs.length > 0 ? /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        padding: 0,
        spacing: 2
    }, standardJobs === null || standardJobs === void 0 ? void 0 : standardJobs.map(function (item, index) {
        var _item$StandardService6, _item$StandardService7;
        return /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sm: 6,
            md: 12,
            key: index
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            width: '100%',
            paddingX: 2,
            paddingTop: 1,
            paddingBottom: 2,
            direction: 'column',
            sx: {
                bgcolor: 'white',
                borderRadius: '8px',
                boxShadow: '0px 0px 16px -4px rgba(16, 24, 40, 0.08)'
            }
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            display: "flex",
            justifyContent: "space-between"
        }, /*#__PURE__*/ React.createElement(MuiCheckBox, {
            id: "standardServiceGroupName-checkbox-".concat(index),
            checkBoxValue: item.isChecked,
            label: /*#__PURE__*/ React.createElement(MuiStack, {
                justifyContent: 'flex-start',
                alignItems: "flex-start"
            }, /*#__PURE__*/ React.createElement(Typography, {
                id: "job-item-name",
                sx: {
                    textTransform: 'capitalize',
                    fontSize: 'base',
                    fontWeight: 'medium',
                    color: 'text.primary'
                }
            }, item === null || item === void 0 ? void 0 : item.StandardServiceGroupName, " ")),
            disabled: isDisabled,
            sx: {
                opacity: isDisabled ? 0.7 : 1
            },
            handleChange: function () { return handleCheckBoxClick(item); }
        }), /*#__PURE__*/ React.createElement(MuiStack, {
            alignItems: "center"
        }, isDesktop ? /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                mr: 1,
                fontSize: 'base',
                fontWeight: 'medium',
                color: 'text.primary'
            }
        }, "\u20B9", ' ', getStandardJobGroupTotal(item)) : null, IsShowGroupItem && /*#__PURE__*/ React.createElement(MuiIconButton, {
            id: "expand-job-item".concat(index),
            onClick: function () { return openJobDetailsDrawer(item, index); }
        }, /*#__PURE__*/ React.createElement(ChevronRightIcon, {
            sx: {
                color: systemColor.primary,
                height: '20px',
                width: '20px'
            }
        })))), !(isDesktop || isMd) && /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Divider, {
            sx: {
                width: '100%'
            }
        })), /*#__PURE__*/ React.createElement(MuiStack, {
            display: 'flex',
            justifyContent: 'space-between',
            paddingTop: 0,
            marginTop: {
                xs: 1.5,
                md: -0.5
            }
        }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                fontSize: 'base',
                fontWeight: 'normal',
                color: 'text.tertiary',
                mr: 0.5,
                marginLeft: {
                    xs: '0px',
                    md: '28px'
                }
            }
        }, "Part -"), /*#__PURE__*/ React.createElement(Typography, {
            id: "job-item-part-count-".concat(index),
            sx: {
                fontSize: 'base',
                fontWeight: 'normal',
                color: 'text.primary'
            }
        }, (_item$StandardService6 = item.StandardServiceAssociation) !== null && _item$StandardService6 !== void 0 && _item$StandardService6.Part ? item.StandardServiceAssociation.Part.length.toString().padStart(2, '0') : '00'), /*#__PURE__*/ React.createElement(Divider, {
            sx: {
                mx: 1.5,
                my: 0.5,
                bgcolor: 'secondary.50'
            },
            orientation: "vertical",
            flexItem: true
        }), /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                fontSize: 'base',
                fontWeight: 'normal',
                color: 'text.tertiary',
                mr: 0.5
            }
        }, "Labour -"), /*#__PURE__*/ React.createElement(Typography, {
            id: "job-item-labour-count-".concat(index),
            sx: {
                fontSize: 'base',
                fontWeight: 'normal',
                color: 'text.primary'
            }
        }, (_item$StandardService7 = item.StandardServiceAssociation) !== null && _item$StandardService7 !== void 0 && _item$StandardService7.Labour ? item.StandardServiceAssociation.Labour.length.toString().padStart(2, '0') : '00')), /*#__PURE__*/ React.createElement(MuiStack, null, !isDesktop && /*#__PURE__*/ React.createElement(Typography, {
            id: "job-item-total-amt-".concat(index),
            sx: {
                mr: 0,
                fontSize: 'base',
                fontWeight: 'medium',
                color: 'text.primary'
            }
        }, "\u20B9", ' ', getStandardJobGroupTotal(item))))));
    })) : /*#__PURE__*/ React.createElement(React.Fragment, null, !isSkeleton && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        paddingBottom: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "standard-job-no-data",
        sx: {
            fontSize: 'base',
            fontWeight: 'normal',
            color: 'text.primary'
        }
    }, t("No Data Found"), "..!!")))), isSkeleton && /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1,
        style: {
            height: '9vh',
            padding: '16px 16px 8px 16px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), isSaveButton && /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'flex-end'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 2,
        mt: 2
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        size: "medium",
        loading: loader.isLoaderOpen,
        name: t("Save"),
        id: "NextButton",
        variant: "outlined",
        color: "primary",
        style: {
            width: "60px"
        },
        disabled: standardJobs.length == 0 || isDisabled || disableSaveButton,
        onClick: handleSaveClick
    }))), /*#__PURE__*/ React.createElement(AlternatePartPopup, {
        alternetPartPopupOpen: alternetPartPopupOpen,
        setAlternetPartPopupOpen: setAlternetPartPopupOpen,
        replacePart: replacePart,
        searchedPart: searchedPart,
        setSearchedPart: setSearchedPart,
        alterNatePartDetails: alterNatePartDetails,
        setAlterNatePartDetails: setAlterNatePartDetails
    }), selectedJobItemDetails && /*#__PURE__*/ React.createElement(StandardJobsPartLabourDetailsDrawer, {
        jobItemDetails: selectedJobItemDetails,
        open: isOpenJobItemDetailsDrawer,
        onClose: function (updatedList) {
            handleClose(updatedList);
        },
        SystemName: SystemName,
        showCheckbox: true,
        isDisabled: true
    }));
};
export default StandaredJobsComponent;
